import { BUILDING_TILE_KINDS, type BuildingTileKind, type TileOwner } from "@dailywars/core/engine";

import { loadCachedImage } from "#/game/cachedImage";

function iconUrl(kind: BuildingTileKind, owner: TileOwner): string {
  return `/buildings/${kind}/icon-${owner}.png`;
}

function occupiedIconUrl(kind: BuildingTileKind, owner: TileOwner): string {
  return `/buildings/${kind}/icon-occupied-${owner}.png`;
}

export function getBuildingIconSrc(kind: BuildingTileKind, owner: TileOwner): string {
  return iconUrl(kind, owner);
}

export function getBuildingIconImage(kind: BuildingTileKind, owner: TileOwner): HTMLImageElement {
  return loadCachedImage(iconUrl(kind, owner));
}

export function getOccupiedBuildingIconSrc(kind: BuildingTileKind, owner: TileOwner): string {
  return occupiedIconUrl(kind, owner);
}

export function getOccupiedBuildingIconImage(
  kind: BuildingTileKind,
  owner: TileOwner,
): HTMLImageElement {
  return loadCachedImage(occupiedIconUrl(kind, owner));
}

export function preloadBuildingIcons(): HTMLImageElement[] {
  const images: HTMLImageElement[] = [];
  for (const kind of BUILDING_TILE_KINDS) {
    for (const owner of ["p1", "p2", "neutral"] as const) {
      images.push(getBuildingIconImage(kind, owner));
      images.push(getOccupiedBuildingIconImage(kind, owner));
    }
  }
  return images;
}
